import React from "react";
import ConfirmModal from "../confirm-modal/confirm-modal";
import { useRouter } from "hooks";
import { Path } from "enums";
import locale from "localization";
import styles from "./download-progress-modal.module.scss";

const DownloadProgressModal = (state) => {
  const { push } = useRouter();

  return (
    <ConfirmModal
      {...state}
      title={locale.yourReportIsBeingPrepared}
      titleStyle={styles.title}
      contentStyle={styles.content}
      content={locale.youCanContinueUsingBosWhileWeGenerateYourReport}
      secondary={{ text: locale.gotIt }}
      primary={{
        text: locale.openDownloads,
        onClick: () => {
          state.close();
          push(Path.Downloads);
        },
      }}
    />
  );
};

export default DownloadProgressModal;
